/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 25.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Classname from 'classnames';

import _get from 'lodash/get';

import {LogIn, LogOut, ForgotPasswordRequest} from '../../actions/auth/actions-auth';
import {LogIn as NarLogIn} from '../../actions/_extentions/nar/actions-nar';

let LogInFn = LogIn;
if (_get(Config, 'operator_ext_id') === 'nar') {
  LogInFn = NarLogIn;
}

import {SetSettingsState} from '../../actions/common/actions-common';

import DivLoader from '../../components/DivLoader/div-loader';
import Translate from '../../components/Translate/translate';

class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formDataUser: '',
      formDataUserForReset: '',
      formDataPassword: '',
      isAuthError: false,
      isForgotError: false,
      isForgot: false
    };
  }

  componentWillReceiveProps(newProps) {
    let state = {};

    state.isAuthError = newProps.auth.isError;
    state.isForgotError = newProps.forgot.isError;

    if (newProps.forgot.isError) {
      state.formDataUserForReset = '';

      setTimeout(function () {
        document.getElementById('reset_username') && document.getElementById('reset_username').focus();

      }, 350);
    }

    this.setState(state);
  }

  _closeError() {

    this.setState({isAuthError: false});
  }

  _onUserNameChange(event) {

    this.setState({formDataUser: _get(event, 'target.value', ''), isAuthError: false});
  }


  _onUserNameForResetChange(event) {

    this.setState({formDataUserForReset: _get(event, 'target.value', ''), isForgotError: false});
  }

  _onPasswordChange(event) {

    this.setState({formDataPassword: _get(event, 'target.value', '')});
  }

  _onSubmitAuth(event = {}) {
    if (event.preventDefault) event.preventDefault();

    this.props.LogIn(this.state.formDataUser, this.state.formDataPassword);
    this.setState({formDataPassword: ''});
  }

  _onSubmitReset(event = {}) {
    if (event.preventDefault) event.preventDefault();

    if (!this.state.formDataUserForReset) {
      setTimeout(function () {
        document.getElementById('reset_username') && document.getElementById('reset_username').focus();

      }, 350);

      return;
    }

    this.props.ForgotPasswordRequest(this.state.formDataUserForReset);
  }

  _openRegistration() {

    this.setState({
      isForgotError: false,
      isAuthError: false,
      isForgot: false
    });

    this.props.SetSettingsState({
      isShown: true,
      tabId: 'registration'
    });
  }

  _openForgot() {

    this.setState({
      formDataUserForReset: this.state.formDataUser,
      isForgotError: false,
      isAuthError: false,
      isForgot: true
    });

    setTimeout(function () {
      document.getElementById('reset_username') && document.getElementById('reset_username').focus();

    }, 350);
  }

  _closeForgot() {

    this.setState({
      isForgotError: false,
      isAuthError: false,
      isForgot: false
    });
  }

  _isForgotDone() {

    return !this.props.forgot.inProgress && this.props.forgot.isSuccess;
  }

  _parseError() {
    const error = _get(this.props, 'auth.errorMsg', '');

    if (error === 'invalid credentials') {
      return '';
    }

    return error;
  }

  _renderForgotForm() {
    const forgotInputClasess = Classname({
      'black-input auth-field': true,
      'error-field': this.state.isForgotError
    });

    return <div>
      <form id="resetForm" className="js-form" role="form" onSubmit={this._onSubmitReset.bind(this)}>
        <span style={{marginLeft: '5px'}}> <Translate content="forgot_password.recovery_password" />: </span>
        <div className="settings-col">
          <Translate id="reset_username"
                     component="input"
                     className={forgotInputClasess}
                     name="email" style={{width: '180px'}}
                     type="text"
                     value={this.state.formDataUserForReset}
                     onChange={this._onUserNameForResetChange.bind(this)}
                     attributes={{placeholder: this.state.isForgotError ? 'forgot_password.wrong_email' : 'forgot_password.login_example'} } />
          <a className="btn-dark reset-password ml" style={{padding: '0 10px'}} href="javascript:void(0)" onClick={this._onSubmitReset.bind(this)}><Translate content="forgot_password.send" /></a>
        </div>
      </form>
    </div>;
  }

  _renderForgotMessage() {
    if (!Config.is_registration_available && _get(Config, 'customer_portal.restore', null)) {
      return <div className="top-auth-error-message">
        <a className="ico-close" onClick={this._closeError.bind(this)}><Translate content="close" /></a>
        <div>
          <strong id="title-error"><Translate content="error.invalid_credentials" /></strong>
          <em id="description-error"><Translate content="error.invalid_credentials_description" /></em>
          <p className="mv">
            {this._parseError()}
          </p>
          <p id="lost-your-password-em mv">
            <a className="lost-your-password" href={Config.customer_portal.restore} target="_blank">
              Take me to Customer Portal
            </a>
          </p>
        </div>
      </div>;
    } else {
      return <div className="top-auth-error-message">
        <a className="ico-close" onClick={this._closeError.bind(this)}><Translate content="close" /></a>
        <div>
          <strong id="title-error"><Translate content="error.invalid_credentials" /></strong>
          <em id="description-error"><Translate content="error.invalid_credentials_description" /></em>
          <p className="mv">
            {this._parseError()}
          </p>
          <p id="lost-your-password-em mv">
            <a className="lost-your-password" href="javascript:void(0)" onClick={this._openForgot.bind(this)}>
              <Translate content="login.lost_your_password" />
            </a>
          </p>
        </div>
      </div>;
    }
  }

  render() {
    return (
      <div className="top-auth-block">
        {Config.is_registration_available && _get(this.props, 'user.user') === 'guest' ?
          <div className="top-auth-register-now">
            {!Config.external_registration ?
                <a className="ico-reg reg-now pointer" href="javascript:void(0)"
                   onClick={this._openRegistration.bind(this)}></a>
                :
                <a className="ico-reg reg-now pointer" href={Config.external_registration} target="_blank"></a>
            }
                <div>
              <strong> <Translate content="registration.texts.title" /> </strong>
              <em> <Translate content="registration.texts.description" /> </em>
            </div>
          </div>
          : null}
        {this.state.isForgot && <div className="form-reset-password" style={{top: '82px', right: '10px'}}>
          <a className="ico-close" href="javascript:void(0)" onClick={this._closeForgot.bind(this)}></a>

          {!this._isForgotDone() && this._renderForgotForm()}

          {this._isForgotDone() && <div>
            <div className="settings-col">
              <em><Translate content="forgot_password.reset_password_success_message" /></em>
            </div>
          </div>}
        </div>}
        {_get(this.props, 'user.user') === 'guest' ?
          <div className="top-auth-login-box">
            <DivLoader loading={this.props.auth.inProgress} />

            {this.state.isAuthError && this._renderForgotMessage()}

            <form id="authForm" className="js-form" role="form" onSubmit={this._onSubmitAuth.bind(this)}>
              <div className="auth-field">
                <label htmlFor="userLogin"><Translate content="login.login" />: </label>
                <Translate component="input"
                           id="userLogin"
                           className="black-input enter-auth-submit"
                           name="username" style={{width: '180px'}}
                           type="text"
                           value={this.state.formDataUser}
                           onChange={this._onUserNameChange.bind(this)}
                           attributes={{placeholder: 'login.login_example'} } />
              </div>
              <div className="auth-field">
                <label htmlFor="userPass"><Translate content="password" />: </label>
                <input type="password" placeholder="******" value={this.state.formDataPassword} onChange={this._onPasswordChange.bind(this)}
                       className="black-input enter-auth-submit" name="password" id="userPass" />
              </div>
              <input className="auth-submit js-submit" type="image" src={`/images/${Config.white_skin ? 'white' : 'black'}/login-btn.png`} />
            </form>
          </div>
          :
          <div className="top-logout-box">
            <div className="user-login-container">
              <strong><Translate content="login.login" /> </strong>
              <span>{_get(this.props, 'user.user')}</span>
            </div>
            <a className="user-logout-link" onClick={this.props.LogOut.bind(this)}><Translate content="logout" /></a>
          </div>
        }
      </div>
    );
  }
}

LoginForm.propTypes = {
  user: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  forgot: PropTypes.object.isRequired
};

const mapStateToProps = ({auth: {user, auth, forgot}}) => ({user, auth, forgot});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({LogIn: LogInFn, LogOut, ForgotPasswordRequest, SetSettingsState}, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/LoginForm/login-form.js